import React from "react";

type ItemProps = {
  title: string;
};

const Item: React.FunctionComponent<ItemProps> = ({ title }) => {
  return (
     <><span>{title}</span></>
  );
};

export default Item;
